import React from "react";
import axios from "axios"
import {useSelector} from "react-redux";
import { Action, Store } from "@byhuz/huz-ui-state";

export default function useAuth(){

    const isChecked=useSelector(state=>state.default?.isChecked||false);
    const isLoggedIn=useSelector(state=>state.default?.loggedIn||false);
    const isPasswordChanged=useSelector(state=>state.default?.passwordChanged||false);
    const isPasswordError=useSelector(state=>state.default?.passwordError||false);
    const user=useSelector(state=>state.default?.user||{});
    //const state=useSelector(state=>state.default||{});

    const login=data=>{

        axios.post('login',data)
            .then(res=>{                
            if (parseInt(res.data.code)===404) {
                Store.dispatch(Action.update("isPasswordError", true));
                Store.dispatch(Action.update("loggedIn", false));
                Store.dispatch(Action.update("user"));
                return false;
            }
    
            if (parseInt(res.data.code)===405) {
              Store.dispatch(Action.update("isPasswordError", false));
              Store.dispatch(Action.update("loggedIn", true));
                return true;   
            }
    
            if (parseInt(res.data.code)===200) {
              Store.dispatch(Action.update("isPasswordError", false));
              Store.dispatch(Action.update("loggedIn", true));
                Store.dispatch(Action.update("user", res.data.payload));
                return true;
            }
            })
            .catch(err=>{
              Store.dispatch(Action.update("isPasswordError", true));
              console.log(err);
            });
    }    

    const changepassword=data=>{
        axios.post('changepassword',data)
            .then(res=>{
            console.log(res);
    
            if (parseInt(res.data.code)===400) {
              Store.dispatch(Action.update("passwordError", true));
              return false;
            }
    
            if (parseInt(res.data.code)===200) {
                Store.dispatch(Action.update("passwordChanged", true));
                return true;
            }
            })
            .catch(err=>{
              console.log(err);
              Store.dispatch(Action.update("passwordError", true));
              return false;
            });
    } 

    const logout=()=>{
        axios.get('logoff')
        .then(res=>{
        })
        .catch(err=>{
          console.log(err);
        }) 
        return true;           
    }

    const checkSession=()=>{
        axios.get('userinfo')
        .then(res=>{
          //console.log("index.js",res);
          if (parseInt(res.data.code)===400) {
            Store.dispatch(Action.update("loggedIn", false));
            Store.dispatch(Action.update("user", res.data.payload));
            return false;
          }

          if (parseInt(res.data.code)===404) {            
            Store.dispatch(Action.update("loggedIn", false));
            return true;
          }

          if (parseInt(res.data.code)===200) {            
            Store.dispatch(Action.update("loggedIn", true));
            Store.dispatch(Action.update("user", res.data.payload));
            return true;
          }
        })
        .catch(err=>{
          console.log(err);
        })
        .finally(()=>{
          Store.dispatch(Action.update("isChecked", true));
        });     
    }

    React.useEffect(()=>{
        if(!isChecked) checkSession();
    },[]);

    return {
        user,
        isLoggedIn,
        isPasswordChanged,
        isPasswordError,
        login,
        logout,
        checkSession,
        changepassword
    };      
}